export enum EQUIFAX_META {
  EQUIFAX_XML_FILE_NAME = 'equifaxCompleteXML.xml',
  LOAN_APPLICATION_FILE_LABEL_CREDIT_FILE = 'creditFile',
  LOAN_APPLICATION_FILE_LABEL_CREDIT_FILE_XML = 'creditFileXml',
  LOAN_APPLICATION_FILE_LABEL_LODGEMENT_FORM = 'lodgementForm',
  EQUIFAX_NO_CREDIT_FILE_FOUND_CODE = '000003',
}

export enum EQUIFAX_BUREAU_META {
  EQUIFAX_XML_MAX_RETRY = 3,
  TIME_BEFORE_NEXT_RETRY_IN_MS = 2000,
  EQUIFAX_TIMEOUT_DURATION = 10000,
  DEFAULT_EQUIFAX_SCORE = 700,
  DEFAULT_VEDA_SCORE = 600,
  DEFAULT_EQUIFAX_ONE_SCORE = 600,
}

export enum EQUIFAX_ACCOUNT_TYPE {
  AUTO_LOAN = 'AL',
  PERSONAL_LOAN_FIX = 'PF',
}
